import Header from './components/Header';
import HeroSection from './components/HeroSection';
import IndexSection from './components/IndexSection';
import RankingSection from './components/RankingSection';
import UpdatesSection from './components/UpdatesSection';
import CardsSection from './components/CardsSection';
import MediaSection from './components/MediaSection';
import TopicsSection from './components/TopicsSection';
import CommentsSection from './components/CommentsSection';
import ContactSection from './components/ContactSection';
import FeaturesSection from './components/FeaturesSection';
import FaqSection from './components/FaqSection';
import CarouselSection from './components/CarouselSection';
import AboutSection from './components/AboutSection';
import AppSection from './components/AppSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <IndexSection />
        <RankingSection />
        <UpdatesSection />
        <CardsSection />
        <MediaSection />
        <TopicsSection />
        <CommentsSection />
        <ContactSection />
        <FeaturesSection />
        <FaqSection />
        <CarouselSection />
        <AboutSection />
        <AppSection />
      </main>
      <Footer />
    </>
  );
}